require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./stag-and-hen-parties.json") })
        }
      }, "path---stag-and-hen-parties");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---stag-and-hen-parties!./.cache/json/stag-and-hen-parties.json
// module id = 697
// module chunks = 231608221292675